import type { Metadata } from '@cigna/shared/metadata-util';
import { Clients, GetNavigationsResponse } from '../+state/appstate.models';

export function extractAdditionalDetails(_metadata?: Metadata) {
  return '0';
}
export function extractSelectedClient(data: GetNavigationsResponse): Clients {
  const defaultClient = data.data?.clients?.find(
    (cls: Clients) => data.data && cls.cs1id === data.data.defaultClientid,
  );

  const initialClientData: Clients = {
    cs1id: 0,
    id: '',
    name: '',
    dlgLevel: 0,
    chatCode: 0,
    sourceCode: '',
    lob: '',
  };

  let selectedClient;

  if (defaultClient) {
    selectedClient = defaultClient;
  } else if (data?.data?.clients) {
    selectedClient = data.data.clients[0];
  } else {
    selectedClient = initialClientData;
  }
  return selectedClient;
}
